import type { SVGProps } from 'react';

const SuccessPtoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.50016 1.33594C4.82016 1.33594 1.8335 4.3226 1.8335 8.0026C1.8335 11.6826 4.82016 14.6693 8.50016 14.6693C12.1802 14.6693 15.1668 11.6826 15.1668 8.0026C15.1668 4.3226 12.1802 1.33594 8.50016 1.33594ZM7.16683 11.3359L3.8335 8.0026L4.7735 7.0626L7.16683 9.44927L12.2268 4.38927L13.1668 5.33594L7.16683 11.3359Z"
        fill="#15B79E"
      />
    </svg>
  );
};

export default SuccessPtoIcon;
